<template>
   <div class="about-nine-section" v-if="about != null">
        <div class="container">
            <div class="section-title-page">
                <h4>{{about.about_nine_section}}</h4>
                <h2>{{about.about_nine_title}}</h2>
            </div>
            <div class="number-of-section">
                <span>05</span>
            </div>
            <div class="elem-decor">
                <img :src="about.about_nine_decor" alt="">
            </div>
        </div>
        <div class="animate-default-images">
            <div class="pic-elem color-pic">
                <img :src="about.about_nine_img" alt="">
            </div>
            <div class="pic-elem black-pic">
                <img :src="about.about_nine_img_black" alt="">
            </div>
        </div>
        <div class="container">
            <div class="pie-items">
                <div class="item" v-for="item in about.about_nine_list">
                    <strong>{{item.title}}</strong>
                    <p v-html="item.desc"></p>
                </div>
            </div>
        </div>
        <!-- <div class="container">
            <div class="sixth-desc">
                <div class="col-left">
                    <p v-html="about.about_sixth_desc_left"></p>
                </div>
                <div class="col-right">
                    <p v-html="about.about_sixth_desc_right"></p>
                </div>
            </div>
        </div> -->
   </div>
</template>

<script>
    export default {
        name: 'about-nine-second',
        components: {
        },
        data () {
            return {
            }
        },
        methods: { 
            
        },
        computed: {
            about() {
                return this.$store.state.about
            },
        },
        created () {
        },
        mounted () {
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about-elems/about-elem-nine.scss';
    // @import '@/styles/components/about/about-respond/about-elem-sixth-respond.scss';
</style>